var map = {
	"./index.js": 89,
	"./messages.js": 314,
	"./notifications.js": 315,
	"./products.js": 316,
	"./tasks.js": 317,
	"./user.js": 318
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = 920
// module chunks = 0